import React from 'react';
const FormatJSON = (props) => {
    return (React.createElement(React.Fragment, null,
        `{`,
        React.createElement("div", null, Object.entries(props.json || {}).map(([key, value]) => {
            if (key === 'hest') {
                console.log(key, value);
            }
            return (React.createElement("div", { key: key, style: { paddingLeft: '20px' } },
                key,
                ":",
                ' ',
                value === null ? ('null') : typeof value === 'object' && !Array.isArray(value) ? (React.createElement(React.Fragment, null,
                    React.createElement(FormatJSON, { json: value }))) : (JSON.stringify(value, null, 2))));
        })),
        `}`));
};
export default FormatJSON;
//# sourceMappingURL=FormatJSON.js.map